// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2g7IF","list":"BalanceDue_list__ypENB","listRow":"BalanceDue_listRow__11H55","total":"BalanceDue_total__2JsIh"};